import { getCurrentLinkCounter } from '../../../Common/Database';

export const countMatchingHomeworks = (students, teacherEmail) => {
  let matchCount = 0;

  students.forEach(student => {
    if (student.homeworks) {
      Object.values(student.homeworks).forEach(homework => {
        if (homework.mail === teacherEmail) {
          matchCount += 1;
        }
      });
    }
  });

  return matchCount;
};

export const countCheckedHomeworks = (students, teacherEmail) => {
  let checkedCount = 0;

  students.forEach(student => {
    if (student.homeworks) {
      Object.values(student.homeworks).forEach(homework => {
        if (homework.mail === teacherEmail && homework.teacherCheckeds) {
          try {
            const checksArray = JSON.parse(homework.teacherCheckeds);

            const allAreTrue = checksArray.every(checkObj => Object.values(checkObj).every(status => status === true));

            if (allAreTrue) {
              checkedCount += 1;
            }
          } catch (e) {
            console.error('Error parsing JSON for teacherCheckeds', e);
          }
        }
      });
    }
  });

  return checkedCount;
};

export const findSubjectsForTeacher = (data, teacherEmail, notebooks) => {
  if (!teacherEmail) {
    console.error('teacherEmail is undefined');
    return;
  }

  const matchedSubjects = [];
  const uniquePages = new Set(); // Сет для хранения уникальных идентификаторов страниц

  data.forEach(item => {
    if (item.subjects) {
      Object.values(item.subjects).forEach(subject => {
        if (
          subject &&
          subject.attachedTeacher &&
          typeof subject.attachedTeacher.id === 'string' &&
          subject.attachedTeacher.id.replace(/\./g, '') === teacherEmail
        ) {
          matchedSubjects.push({
            email: item.email,
            name: subject.name,
          });
        }
      });
    }
  });

  matchedSubjects.forEach(subject => {
    const notebook = notebooks[subject.email.replace(/\./g, '')];
    if (notebook) {
      Object.values(notebook).forEach(level1Obj => {
        Object.values(level1Obj).forEach(level2Obj => {
          // Добавляем идентификаторы проверенных страниц в Set
          if (level2Obj.firstSheet && level2Obj.firstSheet.isReviewed) {
            uniquePages.add(level2Obj.firstSheet.content + level2Obj.firstSheet.order);
          }
          if (level2Obj.secondSheet && level2Obj.secondSheet.isReviewed) {
            uniquePages.add(level2Obj.secondSheet.content + level2Obj.secondSheet.order);
          }
        });
      });
    }
  });

  return uniquePages.size;
};

export const countStudentsWithTeacher = (data, teacherEmail) => {
  if (!teacherEmail) {
    console.error('teacherEmail is undefined');
    return 0;
  }

  let studentCount = 0;
  const matchedStudentsEmails = new Set();

  data.forEach(item => {
    if (item.subjects) {
      Object.values(item.subjects).forEach(subject => {
        if (
          subject &&
          subject.attachedTeacher &&
          subject.attachedTeacher.id &&
          typeof subject.attachedTeacher.id === 'string'
        ) {
          const sanitizedId = subject.attachedTeacher.id.replace(/\./g, '');
          if (sanitizedId === teacherEmail) {
            matchedStudentsEmails.add(item.email);
          }
        }
      });
    }
  });

  studentCount = matchedStudentsEmails.size;

  return studentCount;
};

export const filterMaterialsByMail = (materialsJSON, currentUserEmail, students) => {
  const materials = JSON.parse(materialsJSON);
  const normalizedEmail = currentUserEmail.replace(/\./g, '');

  let filteredMaterials = materials.filter(material => material.mail === normalizedEmail);

  let additionalMaterials = [];

  // Проверяем, что students определены и являются массивом
  if (Array.isArray(students)) {
    students.forEach(student => {
      if (student.materials && typeof student.materials === 'object') {
        Object.values(student.materials).forEach(material => {
          if (material.mail === normalizedEmail && !filteredMaterials.some(m => m.id === material.id)) {
            additionalMaterials.push(material);
          }
        });
      }
    });
  }

  // Конкатенация filteredMaterials и additionalMaterials
  filteredMaterials = filteredMaterials.concat(additionalMaterials);

  return filteredMaterials;
};

export const countMaterialsForStudents = (students, materialsJSON, currentUserEmail) => {
  const filteredMaterials = filterMaterialsByMail(materialsJSON, currentUserEmail, students);

  const currentUserEmailTrim = currentUserEmail.replace(/\./g, '');

  const materialIdsSet = new Set(filteredMaterials.map(material => material.id));
  const sentMaterialIdsSet = new Set();

  students.forEach(student => {
    if (student.materials && typeof student.materials === 'object') {
      Object.values(student.materials).forEach(material => {
        // Проверяем первое условие
        if (materialIdsSet.has(material.id)) {
          sentMaterialIdsSet.add(material.id);
        }

        // Добавляем второе условие
        if (material.mail && material.mail === currentUserEmailTrim && !materialIdsSet.has(material.id)) {
          sentMaterialIdsSet.add(material.id);
        }
      });
    }
  });

  const count = sentMaterialIdsSet.size;

  return count;
};

export const filterMaterialsByMailWithChapter = (materialsJSON, currentUserEmail) => {
  const materials = JSON.parse(materialsJSON);

  const normalizedEmail = currentUserEmail.replace(/\./g, '');

  const filteredMaterials = materials.filter(material => {
    return material.mail === normalizedEmail && material.hasOwnProperty('chapter');
  });

  return filteredMaterials;
};

export const countMaterialsForStudentsWithChapter = (students, materialsJSON, currentUserEmail) => {
  const filteredMaterials = filterMaterialsByMailWithChapter(materialsJSON, currentUserEmail);

  const materialIdsSet = new Set(filteredMaterials.map(material => material.id));

  const checkedMaterialsSet = new Set();

  students.forEach(student => {
    if (student.materials && typeof student.materials === 'object') {
      Object.values(student.materials).forEach(material => {
        if (materialIdsSet.has(material.id) && !checkedMaterialsSet.has(material.id)) {
          checkedMaterialsSet.add(material.id);
        }
      });
    }
  });

  return checkedMaterialsSet.size;
};

export const findCompletedControlSheets = (students, materialsJSON, currentUserEmail) => {
  const filteredMaterials = filterMaterialsByMailWithChapter(materialsJSON, currentUserEmail);

  const materialIdsSet = new Set(filteredMaterials.map(material => material.id));
  let completedCount = 0;

  students.forEach(student => {
    if (student.materials && typeof student.materials === 'object') {
      Object.values(student.materials).forEach(material => {
        if (
          materialIdsSet.has(material.id) &&
          material.courseCompletion &&
          material.courseCompletion.supervisor &&
          material.courseCompletion.supervisor.trim() !== ''
        ) {
          completedCount++;
        }
      });
    }
  });

  return completedCount;
};

export const processUserSessions = user => {
  if (!user || !user.sessionStartTime || user.sessionStartTime.length === 0) {
    return {
      totalCount: 0,
      item1: {
        value: 0,
        label: '0:00-8:00',
        color: '#A9BAF5',
      },
      item2: {
        value: 0,
        label: '8:00-16:00',
        color: '#CCD7FF',
      },
      item3: {
        value: 0,
        label: '16:00-0:00',
        color: '#E4EFFF',
      },
    };
  }

  // Функция для фильтрации уникальных сессий с интервалом в один час
  const getUniqueAndFilteredSessions = sessionDates => {
    const uniqueSessions = Array.from(new Set(sessionDates)).sort((a, b) => new Date(a) - new Date(b));
    const filteredSessions = [];
    uniqueSessions.forEach((dateStr, index) => {
      if (index === 0 || new Date(dateStr) - new Date(filteredSessions[filteredSessions.length - 1]) >= 3600000) {
        filteredSessions.push(dateStr);
      }
    });
    return filteredSessions;
  };

  const uniqueFilteredDates = getUniqueAndFilteredSessions(user.sessionStartTime);

  let count1 = 0;
  let count2 = 0;
  let count3 = 0;

  uniqueFilteredDates.forEach(dateStr => {
    const date = new Date(dateStr);
    const hours = date.getUTCHours();

    if (hours >= 0 && hours < 8) {
      count1 += 1;
    } else if (hours >= 8 && hours < 16) {
      count2 += 1;
    } else {
      count3 += 1;
    }
  });

  return {
    totalCount: uniqueFilteredDates.length,
    item1: {
      value: count1,
      label: '0:00-8:00',
      color: '#A9BAF5',
    },
    item2: {
      value: count2,
      label: '8:00-16:00',
      color: '#CCD7FF',
    },
    item3: {
      value: count3,
      label: '16:00-0:00',
      color: '#E4EFFF',
    },
  };
};

export const generateLinkCounts = (teachers, currentUserEmail) => {
  const teacher = teachers.find(t => t.email === currentUserEmail);
  return teacher?.linkGeneratedCount || 0;
};

export const createMaterialsAllTime = (materialsJSON, currentUserEmail) => {
  const filteredMaterials = filterMaterialsByMail(materialsJSON, currentUserEmail);

  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const getMonthCountObject = monthDiff => {
    const date = new Date();
    date.setMonth(date.getMonth() - monthDiff);
    return {
      count: 0,
      month: monthNames[date.getMonth()],
    };
  };

  let counts = {
    currentMonth: getMonthCountObject(0),
    oneMonthAgo: getMonthCountObject(1),
    twoMonthsAgo: getMonthCountObject(2),
    threeMonthsAgo: getMonthCountObject(3),
    fourMonthsAgo: getMonthCountObject(4),
    fiveMonthsAgo: getMonthCountObject(5),
  };

  const now = new Date();
  const currentMonth = now.getMonth();
  const currentYear = now.getFullYear();

  filteredMaterials.forEach(material => {
    if (material.createTime && material.createTime.seconds) {
      const createDate = new Date(material.createTime.seconds * 1000);
      const createMonth = createDate.getMonth();
      const createYear = createDate.getFullYear();

      let monthDiff = (currentYear - createYear) * 12 + currentMonth - createMonth;

      if (monthDiff >= 0 && monthDiff < 6) {
        switch (monthDiff) {
          case 0:
            counts.currentMonth.count++;
            break;
          case 1:
            counts.oneMonthAgo.count++;
            break;
          case 2:
            counts.twoMonthsAgo.count++;
            break;
          case 3:
            counts.threeMonthsAgo.count++;
            break;
          case 4:
            counts.fourMonthsAgo.count++;
            break;
          case 5:
            counts.fiveMonthsAgo.count++;
            break;
          default:
            break;
        }
      }
    }
  });

  const result = {
    counts: counts,
    totalMaterialsCount: filteredMaterials.length,
  };

  return result;
};
